import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { LanguageContext } from '@/context/LanguageContext';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/routes/routesList';
import messages_en from '@/translations/en.json';
import messages_ar from '@/translations/ar.json';
import messages_ru from '@/translations/ru.json';
import messages_fr from '@/translations/fr.json';
import messages_de from '@/translations/de.json';
var messages = {
    en: messages_en,
    ar: messages_ar,
    ru: messages_ru,
    fr: messages_fr,
    de: messages_de,
};
export var LanguageProvider = function (_a) {
    var children = _a.children;
    var lang = useParams().lang;
    var navigate = useNavigate();
    var location = useLocation();
    var language = SUPPORTED_LANGUAGES.includes(lang)
        ? lang
        : DEFAULT_LANGUAGE;
    var setLanguage = function (newLang) {
        var newPath = location.pathname.replace("/".concat(language), "/".concat(newLang));
        navigate(newPath, { replace: true });
    };
    var contextValue = useMemo(function () { return ({ language: language, setLanguage: setLanguage }); }, [language, location.pathname]);
    return (_jsx(LanguageContext.Provider, { value: contextValue, children: _jsx(IntlProvider, { locale: language, messages: messages[language], defaultLocale: "en", children: children }) }));
};
